(function($, window, document) {
    var defaults = {
        zoom: 14,
        singleMarkerZoom: 15,
        markerIcon: '/static/svg/src/icon-pin.svg',
        markerScale: 1,
        markerAnchor: [0.5, 1],
        draggable: true,
        scrollWheel: false,
        ctrlWheelZoom: true,
        doubleClickZoom: false,
        grayScale: true,
        fitPadding: [70, 70, 70, 70],
        maxFitZoom: 16
    };

    function parseCoordinate(value) {
        if (typeof value === 'string') {
            value = value.replace(',', '.');
        }

        value = parseFloat(value);

        return isNaN(value) ? null : value;
    }

    function getMapOptions($mapEl) {
        return $.extend({}, defaults, {
            zoom: parseInt($mapEl.data('zoom'), 10) || defaults.zoom,
            singleMarkerZoom: parseInt($mapEl.data('single-marker-zoom'), 10) || defaults.singleMarkerZoom,
            markerIcon: $mapEl.data('marker-icon') || defaults.markerIcon,
            markerScale: parseFloat($mapEl.data('marker-scale')) || defaults.markerScale,
            draggable: getBooleanOption($mapEl, 'draggable', defaults.draggable),
            scrollWheel: getBooleanOption($mapEl, 'scroll-wheel', defaults.scrollWheel),
            ctrlWheelZoom: getBooleanOption($mapEl, 'ctrl-wheel-zoom', defaults.ctrlWheelZoom),
            doubleClickZoom: getBooleanOption($mapEl, 'double-click-zoom', defaults.doubleClickZoom),
            grayScale: getBooleanOption($mapEl, 'gray-scale', defaults.grayScale)
        });
    }

    function getBooleanOption($el, name, defaultValue) {
        var value = $el.data(name);

        if (typeof value === 'undefined') {
            return defaultValue;
        }

        return value === true || value === 'true' || value === 1 || value === '1';
    }

    function getMarkers($mapEl) {
        var markers = [];

        $mapEl.find('.marker').each(function() {
            var $marker = $(this);
            var lat = parseCoordinate($marker.attr('data-lat'));
            var lng = parseCoordinate($marker.attr('data-lng'));

            if (lat === null || lng === null) {
                return;
            }

            markers.push({
                lat: lat,
                lng: lng,
                content: $.trim($marker.html())
            });
        });

        return markers;
    }

    function createMarkerStyle(options) {
        if (!options.markerIcon) {
            return null;
        }

        return new ol.style.Style({
            image: new ol.style.Icon({
                anchor: options.markerAnchor,
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                scale: options.markerScale,
                src: options.markerIcon
            })
        });
    }

    function createFeatures(markers, markerStyle) {
        return $.map(markers, function(marker) {
            var feature = new ol.Feature({
                geometry: new ol.geom.Point(ol.proj.fromLonLat([marker.lng, marker.lat]))
            });

            feature.set('content', marker.content);

            if (markerStyle) {
                feature.setStyle(markerStyle);
            }

            return feature;
        });
    }

    function createPopup(map) {
        var popup = document.createElement('div');
        var close = document.createElement('button');
        var content = document.createElement('div');
        var overlay;

        popup.className = 'olmap-popup';
        close.className = 'olmap-popup-close';
        close.type = 'button';
        close.innerHTML = '&times;';
        content.className = 'olmap-popup-content';

        popup.appendChild(close);
        popup.appendChild(content);

        overlay = new ol.Overlay({
            element: popup,
            offset: [0, -38],
            positioning: 'bottom-center',
            stopEvent: true
        });

        close.onclick = function() {
            overlay.setPosition(undefined);
            close.blur();
            return false;
        };

        map.addOverlay(overlay);

        return {
            content: content,
            overlay: overlay
        };
    }

    function ensurePopupStyles() {
        var style;

        if (document.getElementById('olmap-popup-styles')) {
            return;
        }

        style = document.createElement('style');
        style.id = 'olmap-popup-styles';
        style.type = 'text/css';
        style.innerHTML = '.olmap-popup{background:#fff;color:#628090;min-width:12rem;max-width:16rem;padding:.75rem 2rem .75rem .9rem;position:relative;box-shadow:0 8px 18px rgba(0,0,0,.18);font-size:.85rem;line-height:1.35}.olmap-popup:after{content:"";position:absolute;left:50%;bottom:-9px;width:18px;height:18px;background:#fff;transform:translateX(-50%) rotate(45deg)}.olmap-popup-content{position:relative;z-index:1}.olmap-popup-content .head{color:#003163;font-weight:700;margin-bottom:.25rem}.olmap-popup-content p:last-child{margin-bottom:0}.olmap-popup-close{background:none;border:0;color:#9c1f00;cursor:pointer;font-size:1.2rem;line-height:1;padding:0;position:absolute;right:.55rem;top:.45rem;z-index:2}';

        document.head.appendChild(style);
    }

    function bindPopup(map, popup) {
        map.on('singleclick', function(event) {
            var feature = map.forEachFeatureAtPixel(event.pixel, function(clickedFeature) {
                return clickedFeature;
            });
            var content = feature ? feature.get('content') : '';

            if (!content) {
                popup.overlay.setPosition(undefined);
                return;
            }

            popup.content.innerHTML = content;
            popup.overlay.setPosition(event.coordinate);
        });

        map.on('pointermove', function(event) {
            var hit = map.hasFeatureAtPixel(event.pixel);
            map.getTargetElement().style.cursor = hit ? 'pointer' : '';
        });
    }

    function bindCtrlWheelZoom(map, options) {
        var target;
        var handler;

        if (!options.ctrlWheelZoom || options.scrollWheel) {
            return;
        }

        target = map.getTargetElement();
        handler = function(event) {
            var view;
            var currentZoom;
            var zoomDirection;
            var nextZoom;
            var anchor;

            if (!event.ctrlKey) {
                return;
            }

            event.preventDefault();

            view = map.getView();
            currentZoom = view.getZoom();

            if (typeof currentZoom === 'undefined') {
                return;
            }

            zoomDirection = event.deltaY > 0 ? -1 : 1;
            nextZoom = Math.max(view.getMinZoom(), Math.min(view.getMaxZoom(), currentZoom + zoomDirection));
            anchor = map.getCoordinateFromPixel(map.getEventPixel(event));

            view.animate({
                anchor: anchor,
                duration: 150,
                zoom: nextZoom
            });
        };

        try {
            target.addEventListener('wheel', handler, { passive: false });
        } catch (e) {
            target.addEventListener('wheel', handler, false);
        }
    }

    function centerMap(map, features, options) {
        var view = map.getView();
        var extent;

        if (!features.length) {
            return;
        }

        if (features.length === 1) {
            view.setCenter(features[0].getGeometry().getCoordinates());
            view.setZoom(options.singleMarkerZoom);
            return;
        }

        extent = ol.extent.createEmpty();

        $.each(features, function(i, feature) {
            ol.extent.extend(extent, feature.getGeometry().getExtent());
        });

        view.fit(extent, {
            padding: options.fitPadding,
            maxZoom: options.maxFitZoom
        });
    }

    function greyscale(context) {
        var canvas = context.canvas;
        var width = canvas.width;
        var height = canvas.height;
        var imageData = context.getImageData(0, 0, width, height);
        var data = imageData.data;
        var i;
        var value;

        for (i = 0; i < data.length; i += 4) {
            value = 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2];

            if (value === 0) {
                value = 255;
            }

            data[i] = value;
            data[i + 1] = value;
            data[i + 2] = value;
            data[i + 3] = 255;
        }

        context.putImageData(imageData, 0, 0);
    }

    function newOpenlayersMap(el, index) {
        var $mapEl = $(el);
        var options = getMapOptions($mapEl);
        var markers = getMarkers($mapEl);
        var mapElId = $mapEl.attr('id') && $('#' + $mapEl.attr('id')).length === 1 ? $mapEl.attr('id') : 'olmap-' + index;
        var osmLayer;
        var features;
        var vectorSource;
        var vectorLayer;
        var map;
        var popup;

        if (typeof ol === 'undefined' || !ol.Map) {
            return null;
        }

        if (!markers.length) {
            return null;
        }

        ensurePopupStyles();

        $mapEl.attr('id', mapElId);
        $mapEl.find('.marker').remove();

        osmLayer = new ol.layer.Tile({
            source: new ol.source.OSM()
        });

        if (options.grayScale) {
            osmLayer.on('postcompose', function(event) {
                greyscale(event.context);
            });
        }

        features = createFeatures(markers, createMarkerStyle(options));
        vectorSource = new ol.source.Vector({
            features: features
        });
        vectorLayer = new ol.layer.Vector({
            source: vectorSource
        });

        map = new ol.Map({
            target: mapElId,
            layers: [osmLayer, vectorLayer],
            view: new ol.View({
                center: features[0].getGeometry().getCoordinates(),
                zoom: options.zoom
            }),
            controls: ol.control.defaults({
                attribution: false,
                rotate: false
            }),
            interactions: ol.interaction.defaults({
                doubleClickZoom: options.doubleClickZoom,
                dragPan: options.draggable,
                mouseWheelZoom: options.scrollWheel,
                pinchRotate: false
            })
        });

        popup = createPopup(map);
        bindPopup(map, popup);
        bindCtrlWheelZoom(map, options);
        centerMap(map, features, options);

        $mapEl.on('resize', function() {
            setTimeout(function() {
                map.updateSize();
            }, 200);
        });

        $(window).on('resizeEnd', function() {
            map.updateSize();
            centerMap(map, features, options);
        });

        return map;
    }

    window.olMap = function(container) {
        var maps = [];

        $(container).each(function(index, el) {
            var map = newOpenlayersMap(el, index);

            if (map) {
                maps.push(map);
            }
        });

        return maps;
    };

    $(function() {
        var maps = document.querySelectorAll('.olmap');

        if (maps.length) {
            window.olMap(maps);
        }
    });
})(jQuery, window, document);
